import { Block } from "@/backend/models/block";
import { Container } from "@/backend/models/containers/container";
import { useTreeStore } from "../store/TreeStore";
import { ProcedureInstanceBase } from "@/backend/models/procedureInstances/procedureInstanceBase";
import { ImplementationFunction } from "@/backend/models/implementationFunction";
import { ReportItemTreeObject } from "@/types/reportTypes";
import { useReportStore } from "../store/ReportStore";
import { Report } from "@/backend/models/report";

export function useCanAddNestedSection(initItem: Container | Block | ProcedureInstanceBase | ImplementationFunction) {
  const allContainers = useTreeStore((state) => state.containers);
  // if (initItem instanceof Block || initItem instanceof ProcedureBase || initItem instanceof PeripheralFunction) return true;
  if(initItem instanceof Block || initItem instanceof ProcedureInstanceBase || initItem instanceof ImplementationFunction) return true;

  const findParent = (id: string, numberOfParents: number) => {
    const foundParent = allContainers.find((cont) => cont.id === id);
    if (foundParent) {
      return findParent(foundParent.parentId, numberOfParents + 1);
    }
    return numberOfParents;
  };

  const nestedSectionCount = findParent(initItem.parentId, 0);

  return nestedSectionCount < 2;
}

export function useCanAddNestedReportItem(initItem: Report | ReportItemTreeObject) {
  const allReportItems = useReportStore((state) => state.reportItems);
  if (initItem instanceof Report) return true;

  const findParent = (id: string, numberOfParents: number) => {
    const foundParent = allReportItems.find((item) => item.id === id);
    if (foundParent) {
      return findParent(foundParent.parentId, numberOfParents + 1);
    }
    return numberOfParents;
  };

  const nestedSectionCount = findParent(initItem.parentId, 0);
  return nestedSectionCount < 3;
}
